import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";

interface SectionHeaderProps {
    title: string;
    description?: ReactNode;
    icon?: LucideIcon;
    iconColor?: string;
    iconBackground?: string;
    action?: ReactNode;
    className?: string;
}

const SectionHeader = ({
    title,
    description,
    icon: Icon,
    iconColor="text-primary",
    iconBackground="bg-primary-light",
    action,
    className = "gestalt-group border-0 shadow-sm rounded-5 p-6 mb-5",
}: SectionHeaderProps) => {
    return (
        <div className={className}>
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center w-100 gap-4">
                <div className="d-flex align-items-start gap-4 flex-grow-1">
                    {Icon && (
                        <div className={`p-3 rounded-4 flex-shrink-0 ${iconBackground}`}>
                            <Icon size={25} className={iconColor} />
                        </div>
                    )}
                    <div className="flex-grow-1">
                        <h1 className="apple-title mb-2">{title}</h1>
                        {typeof description === "string" ? (
                            <p className="h3 apple-body text-muted fw-normal mb-0">{description}</p>
                        ) : description}
                    </div>
                </div>
                {action}
            </div>
        </div>
    );
};

export default SectionHeader;
